<template>
  <header :class="['site-header', { 'site-header--fixed' : fixed }]">
    <div class="site-header-inner">
      <div class="background"></div>
      <div class="container">
        <router-link :to="{ name: 'home'}">
          <v-logo />
        </router-link>

        <div class="navigation-toggle" @click="toggleNavigation()">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>

        <div class="navigation-hide" v-if="navigationToggle" @click="hideNavigation()"></div>

        <div :class="['navigation-wrapper', { 'navigation-wrapper--active': navigationToggle }]">
          <div class="navigation-wrapper-pointer"></div>
          <!-- <navigation-meta/> -->
          <navigation-main/>
        </div>
      </div>
    </div>
  </header>
</template>

<script>

export default {
  name: 'vHeader',
  data() {
    return {
      dispatchOnce: true,
      fixed: false,
      navigationToggle: false,
    };
  },
  methods: {
    addEventListener() {
      window.addEventListener('scroll', this.handleScroll);

      this.$eventBus.$on(this.$events('GLOBAL.HIDE_NAVIGATION'), () => {
        this.navigationToggle = false
      });
    },
    toggleNavigation() {
      this.navigationToggle = !this.navigationToggle;
    },
    hideNavigation() {
      this.navigationToggle = false;
    },
    handleScroll() {
      let offsetY = window.pageYOffset || document.documentElement.scrollTop;
      if (offsetY > 50 && this.dispatchOnce) {
        this.fixed = true;
        this.dispatchOnce = false;
      } else if (offsetY < 50 && !this.dispatchOnce) {
        this.fixed = false;
        this.dispatchOnce = true;
      }
    },
  },
  created() {
    this.addEventListener();
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  components: {
    vLogo: () => import('@/components/logo'),
    // NavigationMeta: () => import('@/components/navigation-meta'),
    NavigationMain: () => import('@/components/navigation-main'),
  },
};
</script>
